// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__xCksM","rootSmall":"AddTileButton_rootSmall__15bP0"};